<script lang="ts">
    import { getImageSizeUrl } from "@/utils/getImageSizeUrl";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import { container } from "@ui-utils/actions/container";
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Image from "@components/Image/Image.svelte";

    export let images: ReviewEntity["images"];
    export let reviewTitle: string;

    const dispatch = createEventDispatcher();
    const handleClick = (event: Event, idx: number) => {
        dispatch("openReview", {
            images,
            idx,
        });
    };
</script>

{#if images.length}
    <ul
        class={CN("gw-rv-image-list", "gw-list-reset-default-styles")}
        use:container={{ "gw-rv-image-list--small": 600 }}
    >
        {#each images as image, idx (image.id)}
            <li class="gw-rv-image-list__item">
                <BaseButton
                    class="gw-rv-image-list__btn"
                    on:click={(event) => handleClick(event, idx)}
                    ariaLabel={`Open review ${reviewTitle}`}
                >
                    <Image
                        ratio={1 / 1}
                        alt={reviewTitle}
                        src={getImageSizeUrl(image.sizes, "sm") || ""}
                        objectFit="cover"
                        wrapperClassName="gw-rv-image-list__image"
                        backdropClassName="gw-rv-image-list__image-backdrop"
                        blur
                    />
                </BaseButton>

                {#if idx === 1 && images.length > 2}
                    <div class="gw-rv-image-list__image-blur" />
                    <BaseButton
                        on:click={(event) => handleClick(event, idx)}
                        class="gw-rv-image-list__image-blur-text"
                        ariaLabel={`Open review ${reviewTitle}`}
                    >
                        <span>
                            +{images.length - 2}
                        </span>
                    </BaseButton>
                {/if}
            </li>
        {/each}
    </ul>
{/if}

<style lang="postcss">
    .gw-rv-image-list {
        margin-top: 1em;
        display: flex;
        align-items: center;
        gap: 0.625em;
        flex-wrap: nowrap;

        &__item {
            width: 90px;
            height: 90px;
            position: relative;
        }

        &--small &__item {
            width: calc((100% - 0.625em) / 3 - 1px);
            height: auto;
        }

        &--small &__item:nth-child(n + 3) {
            display: none;
        }

        &__image-blur {
            display: none;
        }

        &--small &__image-blur {
            position: absolute;
            top: 0;
            display: block;
            width: 100%;
            height: 100%;
            background-color: #000;
            opacity: 0.5;
            border-radius: 0.375em;
            z-index: 2;
        }

        &__image-blur-text {
            display: none;
        }

        :global(&--small &__image-blur-text) {
            cursor: pointer;
            position: absolute;
            top: 0;
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            color: #fff;
            z-index: 3;

            font-size: 1.625em;
        }
    }

    :global(.gw-rv-image-list__btn) {
        display: block;
        width: 100%;
        height: 100%;
    }

    :global(.gw-rv-image-list__image) {
        border-radius: 0.375em;
    }
</style>
